import type { FC } from 'react';
import { memo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { ReactComponent as IconHierarchyBlue } from '../../icons/icon-hierarchy-blue.svg';
import { useAppSelector } from '../../redux/hooks';
import { getStateMessage } from './thread-slice-utils';

const messages = defineMessages({
  countLabel: {
    defaultMessage: 'Niv. {position}',
    id: 'kDGfZl',
  },
});

interface Props {
  messageId: string | undefined;
}

export const CounterNestedMsg: FC<Props> = memo(function CounterNestedMsg(props) {
  const { messageId } = props;
  const depthIndex = useAppSelector(s => getStateMessage(s.threads.messages, messageId)?.position);

  if (depthIndex == null) return null;

  return (
    <div className={'CounterNestedMsg flex items-center space-x-1'}>
      <IconHierarchyBlue className="w-3 h-3" />
      <span>
        <FormattedMessage {...messages.countLabel} values={{ position: depthIndex + 1 }} />
      </span>
    </div>
  );
});
